import axios from "../../api/axios";
import AuthService from "../auth/AuthService";
import IBuilding from "../../models/building";
import IAdminPageBuildingDetail from "../../models/adminPage/adminPageBuildingDetail";
import IEditBuildingRequest from "../../models/requests/building/editBuildingRequest";
import ITimeZoneInfo from "../../models/timezone";

class BuildingService {
    GetBuildingsDetails = async (): Promise<IAdminPageBuildingDetail[]> => {
        const URI = `/api/hblogin/Building/GetBuildingsDetails`;

        return (
            await axios.get<IAdminPageBuildingDetail[]>(URI, {
                headers: { Authorization: AuthService.guid },
            })
        ).data || [];
    };

    GetBuildingById = async (buildingId: number): Promise<IAdminPageBuildingDetail> => {
        const URI = "/api/hblogin/Building/GetBuilding";
        return (
            await axios.get<IAdminPageBuildingDetail>(
                `${URI}`,
                {
                    headers: { Authorization: AuthService.guid },
                    params: { buildingId }
                }
            )
        ).data;
    };

    GetBuildingsByTenant = async (tenantId: number) => {
        const url = "/api/hblogin/building/GetBuildingsByTenant";
        return (
            await axios.get<IBuilding[]>(url, {
                headers: { Authorization: AuthService.guid },
                params: { tenantId },
            })
        ).data;
    };

    GetBuildingsByUser = async (userId: number): Promise<IBuilding[]> => {
        const URI = `/api/hblogin/building/GetBuildingsByUser`;
        return (await axios.get<IBuilding[]>(URI,
            { params: { userId } })).data;
    };

    PostBuilding = async (buildingRequest: IEditBuildingRequest) => {
        const URI = "/api/hblogin/Building/PostBuilding";
        return (
            await axios.post(URI, JSON.stringify(buildingRequest), {
                headers: { Authorization: AuthService.guid },
            })
        ).data;
    };

    PutBuilding = async (buildingRequest: IEditBuildingRequest) => {
        const URI = "/api/hblogin/Building/PutBuilding";
        return await axios.put(URI, JSON.stringify(buildingRequest), {
            headers: { Authorization: AuthService.guid },
        });
    };

    GetTimeZones = async (): Promise<ITimeZoneInfo[]> => {
        const URI = `/api/hblogin/TimeZone/GetTimeZones`;

        return (
            await axios.get<ITimeZoneInfo[]>(URI, {
                headers: { Authorization: AuthService.guid },
            })
        ).data || [];
    };

    GetDefaultTimeZone = async (): Promise<string> => {
        const URI = `/api/hblogin/TimeZone/GetDefaultTimeZone`;

        return (
            await axios.get<string>(URI, {
                headers: { Authorization: AuthService.guid },
            })
        ).data || "";
    }
    async GetBuildingsByIds(ids: number[]): Promise<IAdminPageBuildingDetail[]> {
        if (ids.length === 0) return [];
        const response = await axios.get<IAdminPageBuildingDetail[]>(`/api/hblogin/building/GetBuildingsByIds`, {
            headers: {
                Authorization: AuthService.guid
            },
            data: ids
        });

        return response.data;
    }
}

const buildingService = new BuildingService();

export default buildingService;
